<input type="file" #file (change)="FileInputHandler()" [accept]="ValidExtensions" />
<button type="text" mat-raised-button [color]="color || 'primary'" (click)="AddFiles()">{{ buttonText }}</button>
